/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


/**
 * An error indicating communication failure with PowerMTA.
 */
export class PmtaError extends Error {
    /**
     * Makes a new PmtaError.
     *
     * @param message
     *      the problem that occurred.
     * @param [csrfToken=undefined]
     *      the CSRF Token recevied from PowerMTA in the failure response. 
     *      Defaults to 'undefined' if not supplied.
     */
    constructor(message, csrfToken = undefined) {
        super(message)
        this.csrfToken = csrfToken
    }
}
